import $ from 'jquery'
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: 'reliquat',
    components: {},
    props: [],
    data() {
        return {
            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),
            curr_month: {},
            filter_date: '',

            is_empty: false,
            is_loading: true,

            fields: [
                'date', { key: 'ref', label: 'Référence' }, 'prestation', { key: 'patient', label: 'Patient' },
                { key: 'espece_recue', label: 'Montant reçu' }, { key: 'reliquat_remis', label: 'Reliquat remis' }, 
                { key: 'reliquat_reporte', label: 'Reliquat reporté' }, 
                { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,

            liste_reliquats: [],

            reglement: {
                montant: '',
                libelle: '',
                user_id: 0,
                compte_id: 0,
                id: 0
            },
            save_loading: false
        }
    },

    watch: {
        curr_month() {
            if (this.curr_month['id'] > 0) {
                this.type_period = 1
                this.period = this.curr_month['id']
                var data = {
                    type_period: this.type_period,
                    period: this.period
                }
                this.getListeReliquat(data)
            }
        },

        filter_date() {
            this.type_period = 2
            this.period = this.filter_date
            var data = {
                type_period: this.type_period,
                period: this.period
            }
            this.getListeReliquat(data)
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.date.getMonth()]

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js
    },

    methods: {
        getListeReliquat(data) {
            this.is_loading = true
            store_operation.getListeReliquats(data).then((reliquats) => {
                this.liste_reliquats = reliquats
                if(this.liste_reliquats.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        }, 

        reglerReliquat(reliquat) {
            this.reglement = {
                id: reliquat.id,
                montant: reliquat.reliquat_reporte,
                libelle: reliquat.prestation,
                user_id: this.user_id,
                compte_id: this.compte_id,
                info_caissier: {
                    nom_caissier: this.userCredentials.user.name,
                    titre: this.userCredentials.user.titre
                }
            }
        },

        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        submit(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                return
            }

            this.save_loading = true

            this.$store.dispatch('reglerReliquat', this.reglement).then((response) => {
                if (response > 0) {
                    this.successToast("Reliquat réglé avec succès")
                    this.$refs.mdl_reglement.click();

                    this.type_period = 1
                    this.period = this.curr_month['id']
                    var data = {
                        type_period: this.type_period,
                        period: this.period
                    }
                    this.getListeReliquat(data)
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        }
    }
}


